/**
 * Fritzbot API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Thoughts } from './thoughts';


export interface FeedbackRequest { 
    answer: string;
    feedback: FeedbackRequestFeedbackEnum;
    feedback_message?: string;
    question: string;
    thoughts?: Array<Thoughts>;
    history?: string;
    conversation_id: string;
}
export enum FeedbackRequestFeedbackEnum {
    Good = 'good',
    Bad = 'bad',
    Unclear = 'unclear'
};



